import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { isNull } from 'lodash'
import { Link } from 'react-router-dom'
import WayPoint from 'react-waypoint'
import { List } from 'material-ui/List'
import { loadMessages, loadMoreMessages } from '../../actions'
import {
  getInboxMessages,
  getOutboxMessages,
  canLoadMoreMessages,
  getTotalMessages,
  getMessagesLoading,
} from '../../selectors'
import Spinner from '../../common/Spinner'
import MessageListItem from '../../common/MessageListItem'
import { Card } from 'material-ui/Card'

const styles = {
  containerStyle: {
    margin: 10,
  },
}

class MessagesList extends PureComponent {
  componentWillMount() {
    if (isNull(this.props.messages)) {
      this.props.loadMessages()
    }
  }

  componentWillReceiveProps(nextProps) {
    // Scroll to top when type of messages showed change
    if (this.props.match.params.type !== nextProps.match.params.type) {
      window.scrollTo(0, 0)
    }
  }

  loadMore = () => {
    this.props.loadMoreMessages()
  }

  render() {
    const {
      messages,
      loading,
      canLoadMore,
      match: { params: { type } },
    } = this.props

    return (
      <div>

        {loading && isNull(messages) && <Spinner centered />}

        {!isNull(messages) &&
          messages.length > 0 &&
          <div>
            {type === 'inbox' &&
              <List>
                {messages.map(message => (
                  <Card style={styles.containerStyle} key={message.id}>
                    <Link to={`/messages/${message.id}`}>
                      <MessageListItem message={message} type={type} />
                    </Link>
                  </Card>
                ))}
              </List>}
            {type === 'outbox' &&
              <div>
                {messages.map(message => (
                  <Card style={styles.containerStyle} key={message.id}>
                    <Link key={message.id} to={`/messages/${message.id}`}>
                      <MessageListItem message={message} type={type} />
                    </Link>
                  </Card>
                ))}
              </div>}
          </div>}

        {/*  Loading more items spinner */}
        {loading &&
          !isNull(messages) &&
          messages.length > 0 &&
          <Spinner centered />}

        {/* Trigger load more */}
        {!loading &&
          !isNull(messages) &&
          messages.length > 0 &&
          canLoadMore &&
          <WayPoint onEnter={this.loadMore} />}

      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  messages: ownProps.match.params.type === 'inbox'
    ? getInboxMessages(state)
    : getOutboxMessages(state),
  totalItems: getTotalMessages(state),
  canLoadMore: canLoadMoreMessages(state),
  loading: getMessagesLoading(state),
})

export default connect(mapStateToProps, {
  loadMessages,
  loadMoreMessages,
})(MessagesList)



// WEBPACK FOOTER //
// ./src/pages/Messages/MessagesList.js